var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logStatus && _vm.logAnswer)?_c('div',[_c('span',{staticClass:"badge",class:_vm.logClasses},[_vm._v(" You answered "+_vm._s(_vm.logAnswer)+" "),_c('i',{staticClass:"fas",class:_vm.logClassesIcon})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }